import React from "react"
import { Countdown, CountdownContainer } from "./styles"

const WebinarCountdown = ({ startDate, heading, onTickCallback }) => (
  <CountdownContainer>
    {heading?.childMarkdownRemark?.html && (
      <h2
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: heading.childMarkdownRemark.html,
        }}
      />
    )}
    <Countdown targetDate={startDate} onTickCallback={onTickCallback} />
  </CountdownContainer>
)

export default WebinarCountdown
